import { appStorage } from '../../helpers';
import { stopEventSource } from '../../server';

/**
 * Perform a simple logout that can be called from anywhere
 * This only cleans the storage and redirects
 */
export const performGlobalLogout = (redirectPath = '/login') => {
  // Log the action
  console.log('Performing logout due to authentication error');

  // Skip if already on login page to prevent loops
  if (
    typeof window !== 'undefined' &&
    window.location.pathname.includes('/login')
  ) {
    return;
  }

  // Clean all application storage
  appStorage.clean();

  // Stop any event source connections
  stopEventSource();

  // Redirect to login page
  if (typeof window !== 'undefined') {
    window.location.href = redirectPath;
  }
};
